import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { LoginComponent } from './pages/login/login.component';
import { ShellComponent } from './pages/shell/shell.component';
import { OverviewComponent } from './pages/overview/overview.component';
import { EmployeesComponent } from './pages/employees/employees.component';
import { PurchasesComponent } from './pages/purchases/purchases.component';
import { CateringComponent } from './pages/catering/catering.component';
import { HelpComponent } from './pages/help/help.component';
import { PortalGuard } from './core/portal.guard';

// Employees is the landing page, not Overview: managing people is what a
// customer signs in to do, and the overview is a summary of it.
const routes: Routes = [
  { path: 'login', component: LoginComponent },
  {
    path: '',
    component: ShellComponent,
    canActivate: [PortalGuard],
    children: [
      { path: 'overview', component: OverviewComponent },
      { path: 'employees', component: EmployeesComponent },
      { path: 'catering', component: CateringComponent },
      { path: 'purchases', component: PurchasesComponent },
      { path: 'help', component: HelpComponent },
      { path: '', pathMatch: 'full', redirectTo: 'employees' }
    ]
  },
  { path: '**', redirectTo: '' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
